import React, {useCallback} from 'react';
import AffiliateSalesSection from './home/AffiliateSalesSection';
import {connect, useDispatch, useSelector} from 'react-redux';
import {Link} from 'react-router-dom';
import {
  EyeClose,
  EyeOpen,
  InstagramIcon,
  PencilIcon,
  PinterestIcon,
  SnapchatIcon,
  TikTokIcon,
  TwitterIcon,
  WebsiteIcon,
  YoutubeIcon,
} from '../../icons/Icons';
import FormattedHelmet from '../cmp/intl/FormattedHelmet';
import {FormattedMessage} from 'react-intl';
import LazyAffiliateSaleDetails from './home/lazy/LazyAffiliateSaleDetails';
import CouponRef from './cmp/CouponRef';
import {
  buildNetworkLink,
  buildRefLink,
} from '@goaffpro/aff-client-commons/functions';
import TopProductsAnalytics from './analytics/TopProductsAnalytics';
import Leaderboard from './analytics/Leaderboard';
import ReferralSources from './analytics/ReferralSources';
import ReferralLink from './home/ReferralLink';
import ConnectedCustomersWidget
  from './connected-customers/ConnectedCustomersWidget';
import ShareBar from '../cmp/ShareBar';
import CopyButton from '../cmp/CopyButton';
import Avatar from '../cmp/Avatar';
import ProductLeaderboard from './analytics/ProductLeaderboard';
import PersonalDiscount from './home/PersonalDiscount';
import ProductCommissionsTableNew
  from './commissions/ProductCommissionsTableNew';
import MLMCommissionsTable from './mlm/MLMCommissionsTable';
import QuickLinks from './home/QuickLinks';
import useToggle from '../cmp/hooks/useToggle';
import RenderCustomLeaderboards
  from './analytics/custom-leaderboards/RenderCustomLeaderboard';
import CompensationPlansRender
  from './compensation-plan/CompensationPlansRender';
import ShopifyMultipassLogin from '../cmp/ShopifyMultipassLogin';


function Home ({
                   name, email, twitter,
                   snapchat, pinterest,
                   tiktok, instagram,
                   partner_website, ref_link,
                   company_name, youtube,
                   profile_photo,
                   badges,
                   ref_tracking_enabled,
                   coupon_tracking_enabled,
                   mlm_enabled,
                   link_type,
                   status,
                   affiliate_shop_domain,
                   ref_code,
                   show_coupon_codes,
                   personal_coupon,
                   personal_message,
                   mlm_tree,
                   reflink_instructions,
                   network_link_page,
                   partner_portal_subdomain,
                   aff_show_connected_customers,
                   aff_show_leaderboard,
                   aff_show_visit_source,
                   aff_show_top_products,
                   aff_show_product_leaderboard,
                   aff_show_order_details,
                   aff_network_link_show,
                  aff_network_commissions_show,
                  aff_show_product_commissions,
                  hide_coupon_section_if_empty,
                  my_coupons,
            }){
    const [showLinks, toggleLinks] = useToggle(true)
    return (
        <>
                <FormattedHelmet id={'navlinkHome'}/>
                <div className={'row justify-content-between'}>
                    {
                        profile_photo && profile_photo.value && profile_photo.value.url &&
                        <Avatar url={profile_photo.value.url}/>
                    }
                    <div className={'col'}>
                        <div className={'d-flex align-items-center'}>
                            <div>
                            <h2>{name}</h2>
                            {
                                company_name &&
                                <div>{company_name}</div>
                            }</div>
                            {
                                badges && badges.slice(0,1).map((url)=>{
                                    return <img src={url} height={48} className={"affiliate_badge mx-2"} alt={"Badge"} />
                                })
                            }
                        </div>
                        <small>{email}</small>
                        <ShopifyMultipassLogin />
                        <p>
                            {
                                twitter && <TwitterIcon className={'mr-2 text-muted'}/>
                            }
                            {
                                instagram && <InstagramIcon className={'mr-2 text-muted'}/>
                            }
                            {
                                partner_website && <WebsiteIcon className={'mr-2 text-muted'}/>
                            }
                            {
                                youtube && <YoutubeIcon className={"mr-2 text-muted"}/>
                            }
                            {
                                tiktok && <TikTokIcon height={'0.95em'} className={"mr-2 text-muted"}/>
                            }
                            {
                                snapchat && <SnapchatIcon className={"mr-2 text-muted"}/>
                            }
                            {
                                pinterest && <PinterestIcon className={"mr-2 text-muted"}/>
                            }
                        </p>
                    </div>
                    {
                        ref_tracking_enabled || coupon_tracking_enabled || mlm_enabled ?
                            <div className={'col-auto'}>
                                <PrivacyMode />
                                <button className={'btn btn-light hide-links-button'} onClick={toggleLinks}>{showLinks ?
                                    <FormattedMessage id={'Hide Links'}/> :
                                    <FormattedMessage id={'Show Links'}/>}</button>
                            </div> : null
                    }
                </div>
                {
                    showLinks &&
                    <div className="py-2">
                        <div className={'row mb-2'}>
                            {
                               ref_tracking_enabled && link_type !== -1 ?
                                <div className="col-md">
                                    {
                                        ref_tracking_enabled && link_type !== -1 &&
                                        <ReferralLink ref_link={ref_link} status={status}/>
                                    }
                                </div> : null
                            }
                            {
                                affiliate_shop_domain && <div className={'col-md mb-4'}><AffiliateStore affiliate_shop_domain={affiliate_shop_domain} ref_code={ref_code} /></div>
                            }
                            {
                                coupon_tracking_enabled && show_coupon_codes && !(hide_coupon_section_if_empty && my_coupons.length === 0) &&
                                <div className="col-md mb-4">
                                    <CouponRef/>
                                </div>
                            }
                            {
                                personal_coupon && personal_coupon.length > 0 && <div className={"col-md"}>
                                    <PersonalDiscount/>
                                </div>
                            }

                        </div>
                        {
                            personal_message &&
                            <p className={"alert alert-info"} style={{whiteSpace: 'pre-line'}}
                               dangerouslySetInnerHTML={{__html: personal_message}}/>
                        }
                        {
                            reflink_instructions &&
                            <div className="card card-body">
                                <div style={{whiteSpace: 'pre-line'}}
                                     dangerouslySetInnerHTML={{__html: reflink_instructions}}
                                />
                            </div>
                        }
                        <QuickLinks />
                        {
                           mlm_enabled && (aff_network_link_show || aff_network_commissions_show) &&
                            <div className={'py-4'}>
                                <div className="row">
                                    {
                                        aff_network_link_show &&
                                        <div className="col-md-6">
                                            <NetworkLink
                                                network_link_page={network_link_page}
                                                partner_portal_subdomain={partner_portal_subdomain}
                                                ref_code={ref_code}
                                            />
                                        </div>
                                    }
                                    {
                                        aff_network_commissions_show &&
                                        <div className="col-md-6">
                                            <h4><FormattedMessage id={'Network Commissions'}/></h4>
                                            <p className={'text-muted'}>
                                                <FormattedMessage id={'networkCommissionDescription'}/>
                                            </p>
                                            <MLMCommissionsTable mlm_tree={mlm_tree}/>
                                        </div>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                }
                {
                   aff_show_product_commissions &&
                    <div className="py-2 border-bottom">
                        <div className="d-flex justify-content-between align-items-center">
                            <h4><FormattedMessage id={"Commission Structure"}/></h4>
                        </div>
                        <ProductCommissionsTableNew/>
                    </div>
                }
                    <CompensationPlansRender />
                    <AffiliateSalesSection/>
                <div className="card-columns">
                    {
                        aff_show_leaderboard && <Leaderboard/>
                    }
                    <RenderCustomLeaderboards />
                    {
                        aff_show_product_leaderboard && <ProductLeaderboard/>
                    }
                    {
                        aff_show_visit_source &&
                        <ReferralSources/>
                    }
                    {
                        aff_show_top_products && <TopProductsAnalytics/>
                    }
                    {
                        aff_show_connected_customers && <ConnectedCustomersWidget/>
                    }

                </div>
                {
                    aff_show_order_details && <div className="mt-4">
                      <LazyAffiliateSaleDetails/>
                    </div>
                }
            </>
    );
}

function NetworkLink({network_link_page, partner_portal_subdomain, ref_code}) {
    const {homepage, signup_page} = buildNetworkLink(network_link_page, partner_portal_subdomain, ref_code);
    if (!network_link_page) {
        const homePage = homepage
        const referral_link = signup_page;
        return (<div>
            <h4><FormattedMessage id={'networkLink'} defaultMessage={'Network Link'}/></h4>
            <p className={'text-muted'}>
                <FormattedMessage id={'Invite others, grow your network, and earn commissions'}/>
            </p>
            <strong><FormattedMessage id={'Signup Link'}/></strong>
            <p>
                <a href={referral_link} target={'_blank'} title={'Referral Link'}
                   className={'d-block'}>{referral_link}</a>
            </p>
            <ShareBar link={referral_link}/>
            <hr/>
            <strong><FormattedMessage id={'Home Page'}/></strong>
            <p>
                <CopyButton text={homePage} title={homePage} className={"px-0 btn btn-link"}/>
            </p>
        </div>);
    } else {
        const homePage = homepage
        return (<div>
            <h4><FormattedMessage id={'networkLink'} defaultMessage={'Network Link'}/></h4>
            <p className={'text-muted'}>
                <FormattedMessage id={'Invite others, grow your network, and earn commissions'}/>
            </p>
            <strong><FormattedMessage id={'Signup Link'}/></strong>
            <p>
                <a href={homePage} target={'_blank'} title={'Referral Link'} className={'d-block'}>{homePage}</a>
            </p>
            <ShareBar link={homePage}/>
        </div>);
    }
}

function AffiliateStore({affiliate_shop_domain, ref_code}){
    if(!affiliate_shop_domain){
        return null;
    }
    return <div>
        <div className="d-flex align-items-center justify-content-between">
            <FormattedMessage tagName={'h4'} id={"Shop"}/>
            <Link className={"btn text-muted"} to={"/edit-shop"}><PencilIcon /></Link>
        </div>

            <p className={"text-muted shop-description"}>
                <FormattedMessage id={"referralLinkDesc"} />
            </p>
            <p>
                <a className={"shop-link"} href={`https://${affiliate_shop_domain}/${ref_code}`} target={"_blank"}>{`https://${affiliate_shop_domain}/${ref_code}`}</a>
            </p>
        <div className="d-flex align-items-center justify-content-between">
            <ShareBar link={`https://${affiliate_shop_domain}/${ref_code}`} />
        </div>
        </div>
}

function PrivacyMode(){
    const privacyMode = useSelector((state)=>state.settings.privacyMode);
    const dispatch = useDispatch()
    const click  = useCallback(()=>{
      console.log('action dispatched', !privacyMode)
      sessionStorage.setItem('privacyMode', String(!!privacyMode))
      dispatch({
        type:'merge-settings',
        settings:{
          privacyMode: !privacyMode
        }
      })
    },[dispatch, privacyMode])
    return <button onClick={click} className={"btn btn-light text-secondary"}>
      {
        privacyMode ? <EyeClose /> : <EyeOpen/>
      }
      </button>
}


const mapStateToProps = (state) => {
    const {
        network_link_page, ref_code, ref_identifiers, website, primary_ref_link, default_referral_link, personal_message, reflink_instructions, is_redirect, signup_data,
        referral_link_params,
        show_coupon_codes,
        affiliate_shop_domain,
        hide_coupon_section_if_empty,
        my_coupons,
        badges,
    } = state.settings;
    const link_type = Number(is_redirect)
    const ref_link = link_type > 0 ? primary_ref_link : buildRefLink(ref_code, primary_ref_link || default_referral_link || website, ref_identifiers, referral_link_params, state.settings);
    const sgnupdata = signup_data ? typeof signup_data === "object" ? signup_data : JSON.parse(signup_data) : [];
    const profile_photo = sgnupdata["profile_photo"]
    return {
        ...state.settings,
        badges,
        show_coupon_codes,
        network_link_page,
        link_type, // 1 = redirect, 0 = normal referral link, -1 = referral link is disabled
        aff_show_product_commissions: state.settings.aff_show_product_commissions,
        aff_network_link_show: state.settings.aff_network_link_show === undefined ? true : state.settings.aff_network_link_show,
        aff_network_commissions_show: state.settings.aff_network_commissions_show === undefined ? true : state.settings.aff_network_commissions_show,
        ref_link,
        status: state.settings.status,
        mlm_tree: state.settings.mlm_tree && JSON.parse(state.settings.mlm_tree),
        coupon_tracking_enabled: state.settings.coupon_tracking_enabled === undefined ? true : state.settings.coupon_tracking_enabled,
        ref_tracking_enabled: state.settings.ref_tracking_enabled === undefined ? true : state.settings.ref_tracking_enabled,
        reflink_instructions,
        personal_message,
        profile_photo,
        affiliate_shop_domain,
        hide_coupon_section_if_empty,
        my_coupons,
    };
};


export default connect(mapStateToProps)(Home);
